export default function HistoryChangeLine({
  label,
  before,
  after,
}: {
  label: string;
  before: string;
  after: string;
}) {
  return (
    <div style={{ overflowWrap: 'anywhere', fontSize: 12, color: 'var(--nb-muted)' }}>
      <strong style={{ color: 'var(--nb-ink)', fontWeight: 700 }}>{label}</strong>{' '}
      <span style={{ color: 'var(--nb-subtle)' }}>{before}</span>
      <span style={{ color: 'var(--nb-faint)' }}>{' → '}</span>
      <span style={{ color: 'var(--nb-ink)', fontWeight: 600 }}>{after}</span>
    </div>
  );
}
